import React from 'react';
import { Navigation } from './components/Navigation';
import { Hero } from './components/Hero';
import { EntireVilla } from './components/EntireVilla';
import { Apartments } from './components/Apartments';
import { Gallery } from './components/Gallery';
import { Amenities } from './components/Amenities';
import { DolceVita } from './components/DolceVita';
import { Testimonials } from './components/Testimonials';
import { Location } from './components/Location';
import { BookingCTA } from './components/BookingCTA';
import { Footer } from './components/Footer';
export function App() {
  return <main className="min-h-screen w-full bg-paper-texture overflow-x-hidden selection:bg-[var(--sage)] selection:text-white" data-id="element-0">
      <Navigation data-id="element-1" />

      <div id="home" data-id="element-2">
        <Hero data-id="element-3" />
      </div>

      <EntireVilla data-id="element-4" />

      <div id="apartments" data-id="element-5">
        <Apartments data-id="element-6" />
      </div>

      <Gallery data-id="element-7" />

      <div id="amenities" data-id="element-8">
        <Amenities data-id="element-9" />
      </div>

      <div id="dolcevita" data-id="element-10">
        <DolceVita data-id="element-11" />
      </div>

      <Testimonials data-id="element-12" />

      <Location data-id="element-13" />

      <BookingCTA data-id="element-14" />

      <div id="contact" data-id="element-15">
        <Footer data-id="element-16" />
      </div>
    </main>;
}